// +----------------------------------------------------------------------
// | URL:/exhibitors-lists   name: 展商列表
// +----------------------------------------------------------------------
export default {
    //第一行，banner 下方
    "上海参展商名录":'CBE-上海参展商名录',
    "展商按钮":'展商',
    "产品按钮":'产品',
    "我的列表":'我的列表',
    // 搜索筛选区域
    "搜索":'搜索',
    "请输入搜索关键字":'请输入搜索关键字',
    "重置":'重置',
    "显示":'显示',
    "条数":'条数',
    "了解更多信息":'了解更多信息',
    "已收藏":'已收藏 ',
    "加入我的收藏":'加入我的列表',
    "地区":'国家/地区',
    "行业":'行业',
    "所在大厅":'所在大厅',
    "展位号":'展位号',
    "类别":'类别',
    "展位":'展位',
    "国家和地区":'国家和地区',
    "展馆":'展馆',
    "品类":'品类',
    "活动专题":'活动专题',
    "公司":'公司',
    "公司简介":'公司简介',
    "产品列表":'产品列表',
    "品牌":'品牌',
    "品牌2":'品牌',
    "预登记":'预登记',
    "价格":'价格',
    "工厂":'工厂',
}